module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":{"serach_history":"Serach History"}}}')
  delete Component.options._Ctor
}
